import React from 'react';
import {Link} from 'react-router-dom';
import { inject, observer } from "mobx-react";

const FaqTextTurkish = ({ feathersStore })=> {
  return(
    <div className="terms-text">
      <h2>Hangi ödeme yöntemlerini kabul ediyorsunuz?</h2>
      <p>
        Ödeme yöntemlerini <Link className="privacy-text" to="/paymentoptions">buradan</Link> görebilirsiniz.
      </p>    
      <h2>
        Siparişim hangi yollarla teslim edilecek?
      </h2>
      <p>
        Teslimat yöntemlerini <Link className="privacy-text" to="/deliveryoptions">buradan</Link> görebilirsiniz.
      </p>
      <h2>
        Siparişimde değişiklik yapabilir miyim?
      </h2>
      <p>
      Siparişiniz kargolanmadan önce değişiklik yapabilirsiniz. Lütfen {feathersStore.settings?.phoneNumbers?.find(p => p.numberEnabled)?.phoneNumber} numarasını arayın veya web sitemizdeki formu <Link className="privacy-text" to="/contact">buradan</Link> doldurarak ya da {feathersStore.settings?.email} adresine e-posta atarak bilgilerinizi ve yapmak istediğiniz değişiklikleri belirtin.
      </p>
      <h2>
        Ziyaret edebileceğim bir mağazanız var mı?
      </h2>
      <p>
      Bizi {feathersStore.settings?.address} adresindeki yerimizde ziyaret edebilirsiniz.
      </p>
    </div>
  )
}
    
export default inject('feathersStore')(observer(FaqTextTurkish));